(() => {
  const config = document.querySelector('[data-tazty-pack-discounts]');
  const enabled = config?.dataset.enabled === 'true';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const codes = [...new Set([config?.dataset.codeFive, config?.dataset.codeTen]
    .map(code => String(code || '').trim()).filter(Boolean))];
  const normalized = code => String(code).trim().toUpperCase();
  const managedCodes = new Set(codes.map(normalized));
  let queue = Promise.resolve();

  const request = async (endpoint, body) => {
    const response = await fetch(`${shopRoot}${endpoint}`, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      signal: AbortSignal.timeout(15000),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'The pack discount could not be updated.');
    return cart;
  };

  async function apply(cart, options) {
    if (!cart?.items) cart = await request('cart.js');
    const existingCodes = (cart.discount_codes || []).map(discount => discount.code).filter(Boolean);
    const hasDiscountedPack = cart.items.some(item => Number(item.quantity) >= 2
      && parseFloat(item.properties?.['_Displayed pack discount']) > 0);
    const ownsCodes = cart.attributes?._tazty_pack_discount_codes === '1';
    if (!hasDiscountedPack && !ownsCodes) return cart;
    // These are standard Shopify codes: the server checks the collections,
    // minimum quantity and combinations, and chooses the best eligible offer.
    const desiredCodes = [...new Set([
      ...existingCodes.filter(code => !managedCodes.has(normalized(code))),
      ...(hasDiscountedPack ? codes : [])
    ])];
    const current = existingCodes.map(normalized).sort().join(',');
    const desired = desiredCodes.map(normalized).sort().join(',');
    if (current === desired && ownsCodes === hasDiscountedPack) return cart;
    return request('cart/update.js', {
      discount: desiredCodes.join(','),
      attributes: { _tazty_pack_discount_codes: hasDiscountedPack ? '1' : '' },
      ...(options.sections?.length ? {
        sections: options.sections, sections_url: window.location.pathname
      } : {})
    });
  }

  window.TaztyPackDiscounts = {
    enabled: enabled && codes.length > 0,
    sync(cart, options = {}) {
      if (!this.enabled) return Promise.resolve(cart);
      // Serialize discount updates; never retry a product add or quantity change.
      const result = queue.then(() => apply(cart, options));
      queue = result.catch(() => {});
      return result;
    }
  };
})();
